import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormlyFieldReadonlyField } from './readonly-field.component';
import { ModulesStore } from '../../../features/admin/modules/modules.store';

@Component({
  selector: 'formly-readonly-entry-object',
  template: `
    <div class="readonly-object" [class]="field.props?.className">
      <formly-readonly-item [data]="formControl.value"></formly-readonly-item>
      @if (field.props?.description) {
        <mat-hint class="inline-block mb-2">{{ field.props?.description }}</mat-hint>
      }
    </div>
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormlyFieldReadonlyField,
  ],
  styles: `
    .readonly-object {
      padding: 10px;
      border-radius: 4px;
    }
    .nested {
      margin-left: 20px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldReadonlyObject extends FieldType {
  modulesStore = inject(ModulesStore);
  constructor() {
    super();
  }
}
